module.exports = {"441621100":"紫城镇","441621102":"龙窝镇","441621103":"九和镇","441621104":"上义镇","441621105":"蓝塘镇","441621106":"凤安镇","441621107":"义容镇","441621108":"古竹镇","441621109":"临江镇","441621110":"柏埔镇","441621111":"黄塘镇","441621112":"敬梓镇","441621114":"水墩镇","441621115":"南岭镇","441621116":"苏区镇","441621117":"瓦溪镇","441621118":"好义镇","441621119":"中坝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441621.json
// module id = 2163
// module chunks = 0